module.exports = __webpack_public_path__ + "static/media/logo-exp.2ecdbf9e.svg";